import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_a1cy3tx6q8: FaireBrandEntity = {
  token: "b_a1cy3tx6q8",
  type: "brand",
  name: "Harp Angel Boutique",
  avatarUrl:
    "https://cdn.faire.com/fastly/5e5fd70e509707b423e8069a805bf31aa8cfb753653f9d96621527b96e636532.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/68a0b0c62910c96669814f0ab7832cb0df135d8d765469c112c18ae8770b725c.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/5e5fd70e509707b423e8069a805bf31aa8cfb753653f9d96621527b96e636532.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/68a0b0c62910c96669814f0ab7832cb0df135d8d765469c112c18ae8770b725c.jpeg",
  location: "PUYALLUP, WA, USA",
  minimumOrderDollars: 300,
  rating: 5,
  reviewCount: 80,
  isTopShop: true,
  isInsider: true,
  description:
    "Harp Angel offers amazingly soft Bamboo and Organic baby apparel and essentials. Our products are mindfully made with the finest quality fabrics that are soft and gentle and naturally hypoallergenic. We only offer our customers high-quality products and work with companies that practice environmentally friendly manufacturing methods with fair and safe working conditions for employees. \nWe are a small husband and wife team with four children and want you to shop with confidence knowing all of our products are ethically made. Thank you for supporting our small business. ",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:45:12.196Z",
    importedBy: "entity-db-cli",
  },
};
